import * as utility from "/assets/src/js/theme/helpers.js";

( function($) {

    /**
     * Inline script data from WordPress
     * - Defined in child theme functions.php
     * =================
     * 
     * Info: Path urls for our website
     * Var: const wordpress
     * @type {Object}
     * 
     */

    //Wait for DOM to load completely before running code
    //-- Support for Avada live builder
    window.addEventListener('DOMContentLoaded', function() {
        const advancedFilters = $('.sa-advanced-filters');
        const expandableLinks = document.querySelectorAll('a[href^="#expandable-"]');

        if (advancedFilters.length != 0) {
            const advancedFiltersPanel = $('.sa-advanced-filters-side-panel');
            const advancedFiltersAccordionLabel = "Filters";
            const advancedFiltersAccordion = "<details class='filter-accordion'></details>";
            let accordionWrap = false;

            $(window).on('load resize', function() {

                if ($(window).width() <= 1024) {
                    
                    if ( ! accordionWrap ) {
                        advancedFiltersPanel.wrap(advancedFiltersAccordion);
                        advancedFiltersPanel.before('<summary>Filters</summary>');
                        accordionWrap = true;
                    }
                } 
                else {

                    if ( accordionWrap ) {
                        $('details.filter-accordion summary').remove();
                        advancedFiltersPanel.unwrap("details");
                        accordionWrap = false;
                    }
                }
            });
        }

        expandableLinks.forEach( function(e) {
            let trigger = e;
            let sectionId = trigger.getAttribute('href').replace('#expandable-', '');
            let section = document.getElementById(sectionId);
            let sectionJquery = jQuery(section);
            const innerSectionWidth = sectionJquery.find('> .fusion-builder-row > .fusion-layout-column > .fusion-column-wrapper').width();
            
            console.dir(sectionJquery)

            sectionJquery.attr('data-inner-width', innerSectionWidth);
            sectionJquery.append(`<style>#${sectionJquery.attr('id')}{--inner-width: ${innerSectionWidth}px;}</style>`);

            trigger.classList.add('expandable', 'expandable-trigger');
            section.classList.add('hidden', 'expandable-section');

            sectionJquery.slideToggle();
            sectionJquery.css({ 'display' : 'none' });

            trigger.addEventListener('click', function(e) {
                e.preventDefault();

                if (! section) {
                    return;
                }

                trigger.classList.toggle('expanded');
                section.classList.toggle('hidden');

                sectionJquery.slideToggle(300, function(){
                    trigger.classList.toggle('finished');
                });
            });
        });
    });

})(jQuery);

( () => {
    const networkBreadcrumbItem = document.querySelector('.network-home');
    const currentSiteBreadcrumbItem = document.querySelector('.awb-home');

    if ( networkBreadcrumbItem && currentSiteBreadcrumbItem ) {
        const currentSiteBreadcrumbItemLinkElement = currentSiteBreadcrumbItem.querySelector('a');
        currentSiteBreadcrumbItemLinkElement.href += '/';
    }
})();